import request from '@/utils/request'

export function phonelogin(data) {
    return request({
        url: '/login/phonelogin',
        method: 'post',
        data
    })
}

export function logout() {
    return request({
        url: '/login/logout',
        method: 'post'
    })
}

export function phonecode(data){
    return request({
        url: '/login/phonecode',
        method:'post',
        data
    })
}

export function refreshToken(){
    return request({
        url: '/login/refresh',
        method:'post',
    })
}


// WEBPACK FOOTER //
// ./src/api/user.js